"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expandable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("..");
var _ahooks = require("ahooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Expandable = function Expandable(_ref) {
  var children = _ref.children,
    _ref$startsExpanded = _ref.startsExpanded,
    startsExpanded = _ref$startsExpanded === void 0 ? false : _ref$startsExpanded,
    _ref$expandTo = _ref.expandTo,
    expandTo = _ref$expandTo === void 0 ? 'bottom' : _ref$expandTo,
    _ref$labelMore = _ref.labelMore,
    labelMore = _ref$labelMore === void 0 ? 'See more' : _ref$labelMore,
    _ref$labelLess = _ref.labelLess,
    labelLess = _ref$labelLess === void 0 ? 'See less' : _ref$labelLess,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'right' : _ref$position,
    _ref$collapsedContent = _ref.collapsedContentHeight,
    collapsedContentHeight = _ref$collapsedContent === void 0 ? 0 : _ref$collapsedContent,
    shadeCollapsed = _ref.shadeCollapsed,
    className = _ref.className,
    labelClassName = _ref.labelClassName,
    iconClassName = _ref.iconClassName;
  var containerRef = (0, _react.useRef)(null);
  var containerSize = (0, _ahooks.useSize)(containerRef.current);
  var containerHeight = containerSize && containerSize.height || Infinity;

  // 1. Always starts expanded, so we can get the actual height of the expanded container at step 4.
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    expandedHeight = _useState4[0],
    setExpandedHeight = _useState4[1];
  (0, _react.useEffect)(function () {
    // 2. Triggers once. Needed to correctly trigger step 4.
    setExpanded(false);
  }, []);
  (0, _react.useEffect)(function () {
    // 3. Should only trigger once. Animates to initial provided startsExpanded state.
    if (containerHeight === Infinity && expandedHeight === 0 && !expanded) {
      setExpanded(startsExpanded);
    }
  }, [expanded]);
  (0, _react.useLayoutEffect)(function () {
    if (containerHeight !== Infinity) {
      // 4. Here, we know containerHeight is actual height, so it is safe to record as expandedHeight
      // In the rest of the file below, expandedHeight is what we use for all calculations
      setExpandedHeight(containerHeight);
    }
  }, [containerHeight]);
  var onExpand = function onExpand() {
    setExpanded(function (expanded) {
      return !expanded;
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('--tag-expandable flex', expandTo === 'top' ? 'flex-col' : 'flex-col-reverse', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overflow-hidden relative",
    style: {
      transition: 'max-height 0.5s ease-in-out 0s',
      // infinity check is needed to not set initial maxHeight to 0, which is important
      // to prevent a CSS transition, on page load, from nothing (0) to expandedHeight.
      maxHeight: expanded && containerHeight !== Infinity ? "".concat(expandedHeight, "px") : "".concat(collapsedContentHeight, "px")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef
  }, children), shadeCollapsed && !expanded && /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute w-full h-[30px] bottom-0 bg-gradient-to-b from-transparent to-white"
  })), collapsedContentHeight < expandedHeight && /*#__PURE__*/_react.default.createElement(ExpandButton, {
    onExpand: onExpand,
    position: position,
    labelClassName: labelClassName,
    label: expanded ? labelLess : labelMore,
    expanded: expanded,
    iconClassName: iconClassName
  }));
};
exports.Expandable = Expandable;
var ExpandButton = function ExpandButton(_ref2) {
  var onExpand = _ref2.onExpand,
    position = _ref2.position,
    labelClassName = _ref2.labelClassName,
    label = _ref2.label,
    expanded = _ref2.expanded,
    iconClassName = _ref2.iconClassName;
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onExpand,
    className: (0, _classnames.default)('cursor-pointer flex items-center text-green1-55', position === 'center' ? 'justify-center' : position === 'right' ? 'justify-end' : 'justify-start', labelClassName)
  }, label, /*#__PURE__*/_react.default.createElement(_.Icon, {
    size: 16,
    type: expanded ? 'caret-up-medium-16' : 'caret-down-medium-16',
    className: (0, _classnames.default)('ml-[8px]', iconClassName)
  }));
};